import React from 'react';
import {connect} from 'react-redux';
import {Switch, Route, useHistory} from 'react-router-dom';
import 'App.css';
import 'assets/styles/index.css';
import NavigationService from 'services/NavigationService';
import Dashboard from 'screens/Dashboard/Dashboard';
import LogIn from 'screens/Auth/Login/Login';
import {lshGETAUTH} from 'services/LocalStorageService';
import {apiSAVEMYPROFILE} from 'constants/Api';
import TokenExpiredScreen from './screens/Auth/TokenExpiredScreen/TokenExpiredScreen';
import {createMuiTheme, ThemeProvider, withWidth} from '@material-ui/core';
import {QuoteDetail} from 'screens/Dashboard/Quotes/QuoteDetail/QuoteDetail';
import {OrderDetailPage} from 'screens/Dashboard/Orders/OrderDetail/OrderDetailPage';
import SocketService from 'services/SocketService';
import {QuoteCreate} from 'screens/Dashboard/Quotes/QuoteCreate/QuoteCreate';
import ForgotPassword from 'screens/Auth/ForgotPassword/ForgotPassword';
import {AppLoader} from './AppLoader';
import {ProductState} from 'appredux/reducers/reducer-products';
import {useNotificationListener} from 'components/HeaderNotifications/NotificationsListener';
import {Breakpoint} from '@material-ui/core/styles/createBreakpoints';
import {PurchaseOrderDetail} from 'screens/Dashboard/PurchaseOrders/PurchaseOrderDetail/PurchaseOrderDetail';
import {PurchaseOrderStatusesState} from 'appredux/reducers/reducer-purchase-order-statuses';
import {DepotState} from 'appredux/reducers/reducer-depots';
import {CreditNoteUpdate} from 'screens/Dashboard/Invoices/CreditNote/CreditNoteUpdate';
import {ProgramCreate} from 'screens/Dashboard/Programs/ProgramCreate/ProgramCreate';
import {CreateProgramState} from 'appredux/reducers/reducer-create-program';
import {CustomerLanding} from 'screens/Dashboard/Customers/CustomerDetail/CustomerLanding';
import {FarmerAcceptInvitation} from 'screens/Auth/FarmerAcceptInvitation';

type AppProps = {
  user: any;
  history: any;
  location: any;
  productState: ProductState;
  depotState: DepotState;
  purchaseOrderStatusesState: PurchaseOrderStatusesState;
  createProgramState: CreateProgramState;
  width: Breakpoint;
};

class App extends React.Component<AppProps> {
  state: {
    loading: boolean;
  } = {
    loading: false, // TODO: Set to true when auth is integrated
  };
  componentDidMount() {
    const {user, history} = this.props;
    NavigationService.setTopLevelNavigator(history);
    SocketService.setupSocket();
    console.log('Environment:', process.env.REACT_APP_ENV);
    if (JSON.stringify(user) === '{}') {
      this.setState({loading: true}, () => {
        lshGETAUTH()
          .then((token) => {
            if (token) {
              SocketService.setOnline(token);
              apiSAVEMYPROFILE()
                .then(() => {
                  const pathName = history.location
                    ? history.location.pathname
                      ? history.location.pathname
                      : ''
                    : '';
                  setTimeout(() => this.setState({loading: false}), 1000);
                  if (pathName.indexOf('login') > -1) {
                    NavigationService.navigate('/');
                  }
                })
                .catch((e) => {
                  console.log('App get profile error:', e);
                  this.setState({loading: false});
                  alert(
                    'Could not fetch user profile at the moment. Please try again later',
                  );
                  NavigationService.navigate('/login');
                });
            } else {
              this.setState({loading: false});
              NavigationService.navigate('/login');
            }
          })
          .catch((e) => console.log('error:', e));
      });
    }
  }
  render() {
    const {loading} = this.state;
    return loading ? (
      <AppLoader />
    ) : (
      <>
        <IListenForNotifications />
        <Switch>
          <Route path="/forgot-password" exact component={ForgotPassword} />
          <Route path="/token-expired" exact component={TokenExpiredScreen} />
          <Route path="/login" exact component={LogIn} />
          <Route
            path="/farmer-accept-invitation"
            exact
            component={FarmerAcceptInvitation}
          />
          <Route
            path="/purchase-orders/:id"
            exact
            render={(props) => (
              <PurchaseOrderDetail
                user={this.props.user}
                purchaseOrderId={props.match.params.id as unknown as number}
                productState={this.props.productState}
                purchaseOrderStatusesState={
                  this.props.purchaseOrderStatusesState
                }
                width={this.props.width}
              />
            )}
          />
          <Route
            path="/orders/:id"
            exact
            render={(props) => (
              <OrderDetailPage
                user={this.props.user}
                orderId={props.match.params.id as unknown as number}
                productState={this.props.productState}
                width={this.props.width}
              />
            )}
          />

          <Route
            path="/quotes/:id"
            exact
            render={(props) => (
              <QuoteDetail
                user={this.props.user}
                quoteId={props.match.params.id as unknown as number}
                productState={this.props.productState}
                width={this.props.width}
              />
            )}
          />
          <Route
            path="/customers/:id"
            exact
            render={(props) => (
              <CustomerLanding
                user={this.props.user}
                customerUserId={props.match.params.id}
                width={this.props.width}
                productState={this.props.productState}
                createProgramState={this.props.createProgramState}
              />
            )}
          />
          <Route
            path="/create-quote"
            exact
            render={() => (
              <QuoteCreate
                user={this.props.user}
                productState={this.props.productState}
                depotState={this.props.depotState}
              />
            )}
          />
          <Route
            path="/create-credit-note"
            exact
            render={() => (
              <CreditNoteUpdate
                user={this.props.user}
                productState={this.props.productState}
                depotState={this.props.depotState}
              />
            )}
          />
          <Route
            path="/create-program"
            exact
            render={() => (
              <ProgramCreate
                user={this.props.user}
                productState={this.props.productState}
                createProgramState={this.props.createProgramState}
              />
            )}
          />
          <Route path="/" component={Dashboard} />
        </Switch>
      </>
    );
  }
}

function IListenForNotifications() {
  useNotificationListener();
  return null;
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    productState: state.products,
    depotState: state.depots,
    purchaseOrderStatusesState: state.purchaseOrderStatuses,
    createProgramState: state.createProgram,
  };
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#387C3F', // Khula green
    },
  },
});

const MainApp = (...props: any) => {
  const history = useHistory();
  return (
    <ThemeProvider theme={theme}>
      <App history={history} {...props[0]} />
    </ThemeProvider>
  );
};

export default connect(mapStateToProps)(withWidth()(MainApp));
